var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import tocDi from "@frameworks/web/components/features/TOC/di/servicelocator";
import { accountDetails } from "@mainDi/webDi";
// components
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import GenericSidebar from "@frameworks/shared-library/components/GenericSidebar";
import ClientSchemeselectionBody from "./ClientSchemeselectionBody";
import SideTxnFooter from "@frameworks/shared-library/components/TransactionJourney/MutualFund/SideTxnFooter";
//Css
import "@frameworks/shared-library/stylesheets/components/TopPerformingFunds/ClientSchemeSelectionBody.scss";
import { EInvestmentType, EReedemType, } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFundConstant";
import ClientAccessValidation from "@frameworks/salesjourney/components/Features/PlaceOrder/AccessControl/ClientAccessValidation";
import { EClientAcntType } from "@frameworks/web/components/features/LoginFlow/constant";
import GenericToast from "@frameworks/shared-library/components/GenericToast";
/**
 * ClientSchemeSelectionSB
 *
 * This component is to open the placing an order flow from Product bouquet screen
 *
 * @param {Function} setVisible
 * @param {ExtendedSideBarSchemeDetails} schemeDetails
 * @param {Function} onClickCancel
 * @param {Function} onClickContinue
 * @param {boolean} loading
 * @param {IClientDetails} ClientDetailsToSidebar
 * @param {Function} setClientDetailsToSidebar
 * @param {IMFSchemeHoldingDetailsList} schemeDataForToc
 * @param {Function} setSchemeDataForToc
 * @param {EInvestmentType} transactionType
 *
 * @returns {}
 */
function ClientSchemeSelectionSB(_a) {
    // *******************************************
    // *           useStates                 *
    // *******************************************
    var _this = this;
    var schemeDetails = _a.schemeDetails, setVisible = _a.setVisible, onClickCancel = _a.onClickCancel, onClickContinue = _a.onClickContinue, ClientDetailsToSidebar = _a.ClientDetailsToSidebar, setClientDetailsToSidebar = _a.setClientDetailsToSidebar, schemeDataForToc = _a.schemeDataForToc, setSchemeDataForToc = _a.setSchemeDataForToc, transactionType = _a.transactionType;
    var _b = __read(useState(false), 2), enableContinue = _b[0], setEnableContinue = _b[1];
    var _c = __read(useState(false), 2), showClientAccessControlSidebar = _c[0], setShowClientAccessControlSidebar = _c[1];
    var _d = __read(useState(), 2), accessControlClientDetails = _d[0], setAccessControlClientDetails = _d[1];
    var _e = __read(useState(true), 2), showSchemeSelectionSidebar = _e[0], setShowSchemeSelectionSidebar = _e[1];
    var _f = __read(useState(), 2), toastDetails = _f[0], setToastDetails = _f[1];
    var _g = __read(useState([]), 2), mfHoldingData = _g[0], setMfHoldingData = _g[1];
    // *******************************************
    // *           GENERATOR FUNCTIONS           *
    // *******************************************
    // NA
    // *******************************************
    // *           HANDLER FUNCTIONS             *
    // *******************************************
    var handleClientSearchSelection = function (data) {
        var _a;
        if (((_a = data === null || data === void 0 ? void 0 : data.ispansearch) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "true") {
            //start access control flow by opening sidebar with these details
            setShowSchemeSelectionSidebar(false);
            setAccessControlClientDetails(data);
            setShowClientAccessControlSidebar(true);
            return;
        }
        updateSelectedClientDetails(data);
    };
    var handleOnClientValidationSuccess = function (data) {
        setShowSchemeSelectionSidebar(true);
        updateSelectedClientDetails(data);
        setShowClientAccessControlSidebar(false);
    };
    // *******************************************
    // *           Miscellaneous                 *
    // *******************************************
    var updateSelectedClientDetails = function (data) {
        var tempData = {
            clientName: data.clientName,
            clientCode: data.accountCode,
            uniqueClientId: data.ucccode,
            userName: data.userName,
            accType: data.accType,
            dpFlag: data.dpFlag,
            direct_plan_enabled_flg: data.direct_plan_enabled_flg,
            clientTier: data.clientTier,
            pan: data.pan,
        };
        setClientDetailsToSidebar(tempData);
        if (data.accType !== EClientAcntType.REG &&
            data.accType !== EClientAcntType.OTC)
            getHoldingData(data.accountCode);
    };
    var getHoldingData = function (clientCode) { return __awaiter(_this, void 0, void 0, function () {
        var _a, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _b = (_a = tocDi.tocJourney)
                        .getMFSchemeHoldingDetail;
                    _c = {};
                    return [4 /*yield*/, accountDetails.getUserLoginType()];
                case 1:
                    _b.apply(_a, [(_c.loginType = _d.sent(),
                            _c.clientCode = clientCode,
                            _c.schemeCode = schemeDetails === null || schemeDetails === void 0 ? void 0 : schemeDetails.schemeCode,
                            _c)])
                        .then(function (data) {
                        var _a;
                        if (((_a = data.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            var output = data.data;
                            if (transactionType === EInvestmentType.STP) {
                                output = data === null || data === void 0 ? void 0 : data.data.filter(function (item) {
                                    return item.folioType === EReedemType.PHYSICAL;
                                });
                            }
                            setMfHoldingData(output);
                            setSchemeDataForToc(output[0]);
                            setEnableContinue(true);
                        }
                    })
                        .catch(function (error) { });
                    return [2 /*return*/];
            }
        });
    }); };
    // *******************************************
    // *           UseEffects                    *
    // *******************************************
    // NA
    // *******************************************
    // *            Rendering                    *
    // *******************************************
    return (React.createElement(React.Fragment, null,
        showSchemeSelectionSidebar && (React.createElement(GenericSidebar, { parentClassname: "client-Search-sidebar-container d-flex flex-column", header: React.createElement("div", { className: "scheme-name-container" },
                React.createElement(GenericSchemeName, { name: schemeDetails === null || schemeDetails === void 0 ? void 0 : schemeDetails.schemeName, subText1: schemeDetails === null || schemeDetails === void 0 ? void 0 : schemeDetails.catName, subText2: schemeDetails === null || schemeDetails === void 0 ? void 0 : schemeDetails.subCatName, image: schemeDetails === null || schemeDetails === void 0 ? void 0 : schemeDetails.amcLogo, maxWidth: 235, showTooltip: true, showImage: true, tooltipPlacement: "bottom", showCategoryTooltip: true })), body: React.createElement(React.Fragment, null,
                toastDetails && (React.createElement(GenericToast, { message: React.createElement("div", { className: "d-flex align-items-center gap-2" },
                        toastDetails.isError ? (React.createElement("span", { className: "edel-icon-red-cross rounded-circle" })) : (React.createElement("span", { className: "edel-icon-tick bg-lime-green rounded-circle" })),
                        React.createElement("span", null, toastDetails.msg)), showHeader: false, position: "bottom-center", showCloseButtonInBody: true, theme: "dark-slate-blue", show: toastDetails.isShow, setClose: function () {
                        setToastDetails({ isShow: false, isError: false, msg: "" });
                    }, autohide: true, parentClassName: "client-access-validation-toast" })),
                React.createElement(ClientSchemeselectionBody, { clientDetails: ClientDetailsToSidebar, setclientDetails: setClientDetailsToSidebar, selectedHolding: schemeDataForToc, setSelectedHolding: setSchemeDataForToc, transactionType: transactionType, mfHoldingData: mfHoldingData, callBackOnClientSearchSelection: handleClientSearchSelection, setEnableContinue: setEnableContinue })), footer: React.createElement("div", { className: "bottom-contents" },
                React.createElement(SideTxnFooter, { leftBtnText: "Cancel", leftBtnOnClick: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        setClientDetailsToSidebar(null);
                        onClickCancel();
                    }, rightBtnOnClick: onClickContinue, rightBtnText: "Continue", rightBtnSubmit: true, isDisableButton: !enableContinue })), openKey: showSchemeSelectionSidebar, setOpenKey: setShowSchemeSelectionSidebar, arrowClose: true, delay: 10, blurBackground: true, onSideBarClose: function () {
                setClientDetailsToSidebar(null);
                setVisible(false);
                onClickCancel();
            } })),
        showClientAccessControlSidebar && (React.createElement(ClientAccessValidation, { setVisible: setShowClientAccessControlSidebar, visible: showClientAccessControlSidebar, clientDetails: accessControlClientDetails, setToastDetails: setToastDetails, callBackOnVerifyClick: handleOnClientValidationSuccess, showBackArrow: true, callBackOnCancelClick: function () {
                setShowSchemeSelectionSidebar(true);
                setShowClientAccessControlSidebar(false);
            }, callBackOnSideBarClose: function () { return setVisible(false); } }))));
}
export default ClientSchemeSelectionSB;
